<template>
  <div id="firmwares">
    <h2>Firmwares</h2>
    <v-layout row wrap>
      <v-flex xs8 class="pl-3">
        <server-table-component v-if="draw"
          table="ota" 
          schema="sch_auth_ota"  
          server="login" 
          >
        </server-table-component>
      </v-flex>
      <v-flex xs4 >
        <DND 
          :filecallback="filecallback" 
          :saveCallback="saveCallback"
          server="login"
        ></DND>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axiosInstances from '@/../../coreui/server/axiosInstances'
import { sync } from 'vuex-pathify'
import DND from '@/../../coreui/library/DragAndDrop'
import { store } from '@/store'

export default {
  components: {
    DND
  },
  data: () => ({
    draw: true
  }),

  methods: {
    filecallback(files) {
      console.log(files)
    },
    saveCallback() {
      console.log('save callback')
      let self = this
      this.draw = false
      setTimeout(() => {
        self.draw = true
      }, 1000);
    }
  }
}
</script>

<style scoped>

</style>
